import Modal from 'antd/lib/modal';

export default Modal;
